<nb-card>
  <nb-card-body>
    <ng-image-slider
      #nav
      [images]="imageObject"
      [infinite]="false"
      [autoSlide]="1"
      [imageSize]="{ width: sWidth, height: sHeight }"
      slideImage="1"
      [manageImageRatio]="true"
      [imagePopup]="false"
      (imageClick)="imageClick($event)"
    ></ng-image-slider>
  </nb-card-body>
</nb-card>
